import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const PRINCIPAL_CONSENT_DATE = 'principal_consent_date'
const PRINCIPAL_CONSENT = 'principal_consent'
const PRINCIPAL_CONSENT_REASON = 'principal_consent_reason'
const PARENT_CONSENT_DATE = 'parent_consent_date'
const PARENT_CONSENT = 'parent_consent'
const PARENT_CONSENT_REASON = 'parent_consent_reason'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [PRINCIPAL_CONSENT_DATE]: {
      label: `Date of principal consent`,
      name: PRINCIPAL_CONSENT_DATE,
      required: true,
    },
    [PRINCIPAL_CONSENT]: {
      label: `Principal consent`,
      name: PRINCIPAL_CONSENT,
    },
    [PRINCIPAL_CONSENT_REASON]: {
      label: `Reason (if no)`,
      name: PRINCIPAL_CONSENT_REASON,
    },
    [PARENT_CONSENT_DATE]: {
      label: `Date of parent consent`,
      name: PARENT_CONSENT_DATE,
      required: true,
    },
    [PARENT_CONSENT]: {
      label: `Parent consent`,
      name: PARENT_CONSENT,
    },
    [PARENT_CONSENT_REASON]: {
      label: `Reason (if no)`,
      name: PARENT_CONSENT_REASON,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [PRINCIPAL_CONSENT_DATE]: null,
  [PRINCIPAL_CONSENT]: false,
  [PRINCIPAL_CONSENT_REASON]: '',
  [PARENT_CONSENT_DATE]: null,
  [PARENT_CONSENT]: false,
  [PARENT_CONSENT_REASON]: '',
}


export default formModel
